import { SimpleEnvBase } from "../EnvBase";
import manifest from "./innogy-charge-manifest.json";
import cs from './i18n/cs-innogyCharge.json';
import en from './i18n/en-innogyCharge.json';
import hu from './i18n/hu-innogyCharge.json';
import de from './i18n/de-innogyCharge.json';
import ro from './i18n/ro-innogyCharge.json';
import sk from './i18n/sk-innogyCharge.json';

export class InnogyChargeEnv extends SimpleEnvBase(manifest) {

	/**
	 * @override
	 */
	get environmentGroup() {
		return "innogy";
	}

	/**
	 * @override
	 * The white label renames the product; that is wording, not styling, so it stays on the
	 * environment rather than moving into the innogy-charge theme.
	 */
	get languagePack() {
		return {
			cs,
			en,
			hu,
			de,
			ro,
			sk,
		};
	}
}

new InnogyChargeEnv();
